import styled, { css } from 'styled-components';

export const NotificationComponentContainer = css`
  ${({ theme }) => theme.mixins.fontWeights.book};

  display: flex;
  align-items: center;
`;

export const NotificationIconPadding = css`
  padding-right: 18px;
`;

export const CheckmarkIconContainer = styled.div`
  display: inline-block;
  margin-right: 15px;

  .hv-svg svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;

    path {
      fill: ${({ theme }) => theme.colors.actionGreen};
    }
  }
`;
